module.exports = __webpack_public_path__ + "static/media/stockhausen_graz_5.3ce02ff0.jpg";